const getUserEmailInputName = (process) => {
  return process.type == 'offboarding' ? 'currentUserEmail' : 'newUserEmail'
  // return {email: , street: }
  // Använd även på start-onboarding/offboarding sidor
  // Eller ta bort och ha bara user... och newUser...
}

export default getUserEmailInputName